import {
    CREATE_PRODUCT_RELATED,
    CREATE_PRODUCT_RELATED_SUCCESS,
    DELETE_PRODUCT_RELATED,
    DELETE_PRODUCT_RELATED_SUCCESS,
    FETCH_ONE_PRODUCT_RELATED,
    FETCH_ONE_PRODUCT_RELATED_SUCCESS,
    PRODUCT_RELATED_LIST_FILTER_UPDATE,
    PRODUCT_RELATED_LIST_FILTER_CATEGORY,
    PRODUCT_RELATED_LIST_PAGE,
    PRODUCT_RELATED_LIST_SORT,
    SORT_ASC,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'id',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    loading: false,
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case CREATE_PRODUCT_RELATED:
        case DELETE_PRODUCT_RELATED:
        case FETCH_ONE_PRODUCT_RELATED:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_ONE_PRODUCT_RELATED_SUCCESS:
            const fetchProductRelatedPayload = utils.mapToObject(action.response.results, (value) => {
                return value.related_product_id;
            });

            return Object.assign({}, state, {
                loading: false,
                data: Object.assign({}, state.data, {
                    [action.productId]: fetchProductRelatedPayload,
                }),
            });

        case CREATE_PRODUCT_RELATED_SUCCESS:
            const createProductRelatedPayload = Object.assign(
                {},
                state.data[action.productId],
                {
                    [action.response.related_product_id]: action.response,
                }
            );

            return Object.assign({}, state, {
                loading: false,
                data: Object.assign({}, state.data, {
                    [action.productId]: createProductRelatedPayload,
                }),
            });

        case DELETE_PRODUCT_RELATED_SUCCESS:
            const newProductRelatedPayload = reducerHelper.removeItemFromObject(
                state.data[action.productId],
                action.productRelatedId
            );

            return Object.assign({}, state, {
                loading: false,
                data: Object.assign({}, state.data, {
                    [action.productId]: newProductRelatedPayload,
                }),
            });

        case PRODUCT_RELATED_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        case PRODUCT_RELATED_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case PRODUCT_RELATED_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case PRODUCT_RELATED_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/productRelatedReducer.js